import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const EchocardiographyNav = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [value, setValue] = useState("/echocardiography");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = [
      "/echocardiography",
      "/echocardiography/test-result",
      "/echocardiography/echo-type",
    ];

    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/echocardiography");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable" // Enables scrollable tabs on smaller screens
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" }, // Ensures tabs have a minimum width
            }}
          >
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/echocardiography"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/echocardiography" ? "white" : "black",
              }}
              label={t("echo.dashboard")}
              value="/echocardiography"
              component={NavLink}
              to="/echocardiography"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/echocardiography/test-result"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/echocardiography/test-result" ? "white" : "black",
              }}
              label={t("echo.testResult")}
              value="/echocardiography/test-result"
              component={NavLink}
              to="/echocardiography/test-result"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/echocardiography/echo-type"
                    ? theme.palette.primary.main
                    : "white",
                color:
                  value === "/echocardiography/echo-type" ? "white" : "black",
              }}
              label={t("echo.echoType")}
              value="/echocardiography/echo-type"
              component={NavLink}
              to="/echocardiography/echo-type"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default EchocardiographyNav;
